export default {
  maskNational(value) {
    return value
      .replace(/[^\d]/g, '')
      .replace(
        /(\d{3})(\d{0,3})(\d{0,4})/,
        (match, p1, p2, p3) => {
          if (p3) {
            return `(${p1}) ${p2}-${p3}`;
          } else if (p2) {
            return `(${p1}) ${p2}`;
          } else if (p1) {
            return `(${p1}`;
          }
          return '';
        },
      );
  },

  maskDotted(value) {
    return value
      .replace(/[^\d]/g, '')
      .replace(
        /(\d{3})(\d{0,3})(\d{0,4})/,
        (match, p1, p2, p3) => {
          if (p3) {
            return `${p1}.${p2}.${p3}`;
          } else if (p2) {
            return `${p1}.${p2}`;
          } else if (p1) {
            return `${p1}`;
          }
          return '';
        },
      );
  },

  maskDashed(value) {
    return value
      .replace(/[^\d]/g, '')
      .replace(
        /(\d{3})(\d{0,3})(\d{0,4})/,
        (match, p1, p2, p3) => {
          if (p3) {
            return `${p1}-${p2}-${p3}`;
          } else if (p2) {
            return `${p1}-${p2}`;
          } else if (p1) {
            return `${p1}`;
          }
          return '';
        },
      );
  },

  maskSSN(value) {
    return value
      .replace(/[^\d]/g, '')
      .replace(
        /(\d{3})(\d{0,2})(\d{0,4})/,
        (match, p1, p2, p3) => {
          if (p3) {
            return `${p1}-${p2}-${p3}`;
          } else if (p2) {
            return `${p1}-${p2}`;
          } else if (p1) {
            return `${p1}`;
          }
          return value;
        },
      );
  },

  maskNoop(value) { return value },

  maskFunction() {
    const format = this.el.dataset.mask;

    switch (format) {
      case 'phone-national':
        return this.maskNational;
      case 'phone-dotted':
        return this.maskDotted;
      case 'phone-dashed':
        return this.maskDashed;
      case 'ssn':
        return this.maskSSN;
      default:
        console.log(`Unknown input mask format ${format}`)
        return this.maskNoop;
    }
  },

  mounted() {
    const maskFn = this.maskFunction();

    this.el.addEventListener('input', e => {
      const input = this.el.value;
      this.el.value = maskFn(input);
    })
  }
}
